<div class="side-bar-container" [ngClass]="{ collapsed: burgerOpen }">
  <div class="scroll-container">
    <div id="container-info" class="container-info">
      <div class="content-dynamic-container">
        <div class="label-span">
          <label>{{ "report.item.operatingCompany" | translate }}</label>
          <span>{{ report?.responsible?.orgDescription }} - {{ report?.responsible?.orgCode }}</span>
        </div>
      </div>
      <div class="content-dynamic-container flex-row">
        <div class="label-span flex-1" [ngClass]="{ 'due-date': isEditableAsResponsible }">
          <label>{{ "report.item.dueDate" | translate }}</label>
          <span>{{ report?.dueDate | date }}</span>
        </div>
        @if (IS_PRODUCT_SAFETY_PROJECT) {
          @if (isEditableAsResponsible) {
            <div class="flex-1">
              <sag-ui-date-range-picker
                [formGroup]="dateRangePickerFormGroup"
                formControlNameStart="reportStartDate"
                formControlNameEnd="reportEndDate"
                [label]="'Reporting period'"
                [placeholder]="'MM/DD/YYYY - MM/DD/YYYY'"
                [disabled]="true"
                (click)="dateRangePickerChanged()" />
            </div>
          } @else {
            @if (report?.reportStartDate) {
              <div class="label-span flex-1">
                <label>{{ "report.item.reportStartDate" | translate }}</label>
                <span>{{ report?.reportStartDate | date }}</span>
              </div>
            }
            @if (report?.reportEndDate) {
              <div class="label-span flex-1">
                <label>{{ "report.item.reportEndDate" | translate }}</label>
                <span>{{ report?.reportEndDate | date }}</span>
              </div>
            }
          }
        } @else if (IS_TRS_PROJECT) {
          <div class="flex-1">
            <sag-ui-date-range-picker
              [formGroup]="dateRangePickerFormGroup"
              formControlNameStart="reportStartDate"
              formControlNameEnd="reportEndDate"
              [label]="'Reporting period'"
              [placeholder]="'MM/DD/YYYY - MM/DD/YYYY'"
              [disabled]="true"
              (click)="dateRangePickerChanged()" />
          </div>
        }
      </div>
      <div id="functions" class="content-dynamic-container same-row">
        <div class="label-span flex-1">
          <label [innerHTML]="'report.item.specialistFunctionLines' | translate"></label>
          <reporting-tool-chip [readonly]="true" [showIconForValues]="{ icon: ['fas', 'signature'], values: mainSpecialists }" [value]="specialists" />
        </div>
        <div class="label-span flex-1">
          <label [innerHTML]="'report.item.executiveMemberLines' | translate"></label>
          <reporting-tool-chip [readonly]="true" [showIconForValues]="{ icon: ['fas', 'signature'], values: mainResponsible }" [value]="responsible" />
        </div>
      </div>
      <div class="content-dynamic-container">
        <div id="specialist-signature" class="content-dynamic-container">
          @if (IS_TRS_PROJECT) {
            <label>{{ "report.item.specialistSignature" | translate }}</label>
            <div class="signature-meta-container">
              <div class="signature-text">
                @for (signer of specialistSigners; track signer) {
                  @if (signatureForSigner(signer.id)) {
                    <span class="signature-meta" [ngClass]="'trs'">
                      {{
                        "report.item.signedByTime"
                          | translate
                            : {
                                date: (signatureForSigner(signer.id).date | localizedDate: "standard"),
                                user: signatureForSigner(signer.id).fullName
                              }
                      }}
                    </span>
                  } @else {
                    <span class="signature-meta" [ngClass]="'trs'"> {{ "report.item.notSignedYet" | translate }} ({{ signer.fullName }}) </span>
                  }
                }
              </div>
              <div class="signature-icon">
                <fa-icon [icon]="['fas', 'signature']" size="2x" />
                <fa-icon [icon]="['fas', reportSignedBySpecialists ? 'check' : 'times']" [ngClass]="{ done: reportSignedBySpecialists }" class="validator" />
              </div>
            </div>
          } @else if (IS_PRODUCT_SAFETY_PROJECT) {
            <label>{{ "report.item.specialistSignature" | translate }}</label>
            <div class="signature-meta-container">
              <div class="signature-text">
                @if (specialistSignature) {
                  <span class="signature-meta" [ngClass]="'product-safety'">
                    {{
                      "report.item.signedByTime"
                        | translate
                          : {
                              date: (singleSignatureResult(specialistSignature).date | localizedDate: "standard"),
                              user: singleSignatureResult(specialistSignature).fullName
                            }
                    }}
                  </span>
                } @else {
                  <span class="signature-meta" [ngClass]="'product-safety'">
                    {{ "report.item.notSignedYet" | translate }}
                  </span>
                }
              </div>
              <div class="signature-icon">
                <fa-icon [icon]="['fas', 'signature']" size="2x" />
                <fa-icon class="validator" [ngClass]="{ done: !!specialistSignature }" [icon]="['fas', !!specialistSignature ? 'check' : 'times']" />
              </div>
            </div>
          }
        </div>
      </div>
      <div class="content-dynamic-container">
        <div id="executive-signature" class="content-dynamic-container">
          <label>{{ "report.item.responsibleSignature" | translate }}</label>
          <div class="signature-meta-container">
            <div class="signature-text">
              @if (responsibleSignature) {
                @if (responsibleSignature.id) {
                  <span class="signature-meta" [ngClass]="IS_TRS_PROJECT ? 'trs' : 'product-safety'">
                    {{
                      "report.item.signedByTime"
                        | translate
                          : {
                              date: (responsibleSignature.date | localizedDate: "standard"),
                              user: responsibleSignature.fullName
                            }
                    }}
                  </span>
                } @else {
                  <span class="signature-meta" [ngClass]="IS_TRS_PROJECT ? 'trs' : 'product-safety'">
                    {{ "report.item.signatureTime" | translate: { date: (responsibleSignature.date | localizedDate: "standard") } }}
                  </span>
                }
              } @else {
                <span class="signature-meta" [ngClass]="IS_TRS_PROJECT ? 'trs' : 'product-safety'">
                  {{ "report.item.notSignedYet" | translate }}
                </span>
              }
            </div>
            <div class="signature">
              @if (isResponsibleForReport) {
                <fa-icon [icon]="['fas', 'question-circle']" (click)="openResponsibleInfoDialog()" class="info-icon" />
              }
              @if (isAbleToSignAsResponsible) {
                <button (click)="signAsResponsible()" class="sign-button">
                  <span class="sign-label">Sign</span>
                  <fa-icon [icon]="['fas', 'signature']" size="2x" />
                </button>
              }
              @if (!isAbleToSignAsResponsible || isReleased) {
                <div class="signature-icon">
                  <fa-icon [icon]="['fas', 'signature']" size="2x" />
                  <fa-icon [icon]="['fas', !!responsibleSignature ? 'check' : 'times']" [ngClass]="{ done: !!responsibleSignature }" class="validator" />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="pie-chart" #container class="circle-container flex-1">
      <div class="circle">
        <circle-progress
          [innerStrokeColor]="innerStrokeColor"
          [innerStrokeWidth]="radius / 12"
          [outerStrokeColor]="outerStrokeColor"
          [outerStrokeWidth]="radius / 10"
          [percent]="report?.doc * 100"
          [radius]="radius"
          [responsive]="true"
          [space]="radius / 20"
          [subtitleFontSize]="radius / 6 + ''"
          [titleFontSize]="radius / 2 + ''"
          [unitsFontSize]="radius / 2 + ''" />
      </div>
    </div>
  </div>
  <div class="toggle-button" (click)="burgerOpen = !burgerOpen">
    <fa-icon icon="{{ burgerOpen ? 'times' : 'info' }}" />
  </div>
</div>
